<!--
 * @Description: What's this for
 * @Autor: WangYuan
 * @Date: 2021-09-28 17:23:56
 * @LastEditors: Yehon He 1427749162@qq.com
 * @LastEditTime: 2025-04-06 23:41:37
-->
<template>
    <div class="manage">
        <div class="manage-body">
            <el-tabs v-model="activeName" @tab-click="handleTabClick">
                <el-tab-pane v-for="(item, index) in tabs" :key="item._id" :label="item.name" :name="item.name"
                    :lazy="true" class="tab-pane">
                    <component :is="item.componentName" :key="item._id" :type-id="item._id"
                        :ref="(el) => (componentRefs[item.componentName] = el)"></component>
                </el-tab-pane>
            </el-tabs>
        </div>
    </div>
</template>

<script>
import ImgManage from "./components/ImgManage.vue";
import VideoManage from "./components/VideoManage.vue";
import DocManage from "./components/DocManage.vue";
import ArticleManage from "./components/ArticleManage.vue";
import { getCategories } from "@/api/material";

const COMPONENT = new Map([
    ["图片", "ImgManage"],
    ["视频", "VideoManage"],
    ['文档', 'DocManage'],
    ['新闻', 'ArticleManage'],
]);
export default {
    name: "material-center",
    components: {
        ImgManage,
        VideoManage,
        DocManage,
        ArticleManage
    },

    data() {
        return {
            activeName: "img",
            tabs: [],
            componentRefs: [],
        };
    },
    created() {
        getCategories().then((res) => {
            const { data } = res;
            if (data) {
                this.tabs = data
                    .map((item) => {
                        if (COMPONENT.get(item.name)) {
                            item.componentName = COMPONENT.get(item.name);
                            return item;
                        }
                    })
                    .filter(Boolean);
                this.activeName = this.tabs[0].name;
            }
        });
    },
    methods: {
        handleTabClick(tab) {
            const childComponent = this.componentRefs[COMPONENT.get(tab.name)];
            if (childComponent) {
                childComponent.initList(); // 调用子组件方法
            }
        },
    },
};
</script>

<style lang="scss" scoped>
.manage {
    padding: 20px;
    height: 100%;


    .manage-body {
        width: 100%;
        height: 100%;
        padding: 10px;
        background: #fff;

        .advertising {
            display: flex;
            align-items: center;
            justify-content: center;
            width: 100%;
            height: 100%;
            cursor: pointer;

            .advertising-title {
                margin-top: 40px;
                font-size: 29px;
                font-weight: 550;
                color: #fff;
                letter-spacing: 2px;
            }

            .advertising-sub {
                margin-top: 30px;
                font-size: 18px;
                font-weight: 500;
                color: #fff;
                letter-spacing: 1px;
            }

            .advertising-btn {
                display: inline-block;
                margin-top: 30px;
                padding: 8px 24px;
                border-radius: 2px;
                font-size: 14px;
                background: #fff;
                letter-spacing: 1px;
            }

            .advertising-image {
                width: 120px;
                // height: 220px;
                margin-left: 40px;
            }
        }
    }
}

::v-deep .el-tabs {
    height: 100%;
    display: flex;
    flex-direction: column;
}

::v-deep .el-tabs__item {
    font-weight: bold;
}

::v-deep .el-tabs__content {
    flex: 1;
    overflow-y: auto;
}

::v-deep .tab-pane {
    height: 100%;
}
</style>
